import React from "react";

class Header extends React.Component {
  render() {
    return (
      <header className="header">
        <h1>NEWS</h1>
        <p>News fetched from Gnews Api</p>
      </header>
    );
  }
}

export default Header;
